var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as React from "react";
import * as _ from 'lodash';
import ResultView from "../presentation/search-results";
import axios from 'axios';
import CONSTS from "../consts";
const queryString = require('query-string');
export default class SearchResults extends React.Component {
    constructor(props) {
        super(props);
        this.allFacets = ['ConsumerType', 'Country', 'ConsumerCategory', 'Region', 'Vintage',
            'IBU', 'Aroma', 'ConsumerVarietal', 'Colour', 'Container', 'SizeAsFloat', 'AgentName',
            'Supplier', 'AlcoholAsFloat', 'SweetnessAsFloat'];
        this.facetOptionMap = {
            ConsumerType: { inFilterOptions: false, location: 'categoryTypes', bodyValues: ['ConsumerType'], parseNumber: '' },
            ConsumerCategory: { inFilterOptions: false, location: 'categories', bodyValues: ['ConsumerCategory'], parseNumber: '' },
            Country: { inFilterOptions: true, location: 'Country', bodyValues: ['country'], parseNumber: '' },
            Vintage: { inFilterOptions: true, location: 'Vintage', bodyValues: ['vintage'], parseNumber: '' },
            Region: { inFilterOptions: true, location: 'Region', bodyValues: ['region'], parseNumber: '' },
            ConsumerVarietal: { inFilterOptions: true, location: 'Varietal', bodyValues: ['ConsumerVarietal'], parseNumber: '' },
            Colour: { inFilterOptions: true, location: 'Colours', bodyValues: ['colour'], parseNumber: '' },
            Container: { inFilterOptions: true, location: 'Containers', bodyValues: ['container'], parseNumber: '' },
            SizeAsFloat: { inFilterOptions: true, location: 'Volumes', bodyValues: ['volumeMin', 'volumeMax'], parseNumber: 'float' },
            AgentName: { inFilterOptions: true, location: 'Agents', bodyValues: ['agentName'], parseNumber: '' },
            Supplier: { inFilterOptions: true, location: 'Suppliers', bodyValues: ['supplier'], parseNumber: '' },
            AlcoholAsFloat: { inFilterOptions: true, location: 'PercentAlcohols', bodyValues: ['percAlcMin', 'percAlcMax'], parseNumber: 'float' },
            SweetnessAsFloat: { inFilterOptions: true, location: 'Sweetnesses', bodyValues: ['sweetMin', 'sweetMax'], parseNumber: 'float' },
            IBU: { inFilterOptions: true, location: 'Ibus', bodyValues: ['ibuMin', 'ibuMax'], parseNumber: 'int' },
            Aroma: { inFilterOptions: true, location: 'Aromas', bodyValues: ['aroma'], parseNumber: '' }
        };
        this.orderByOptions = [
            { label: 'Relevancy', value: 'search.score()+desc' },
            { label: 'Product Name - A - Z', value: 'Name+asc' },
            { label: 'Product Name - Z - A', value: 'Name+desc' },
            { label: 'SKU # - 0 - 9', value: 'DisplaySKU+asc' },
            { label: 'SKU # - 9 - 0', value: 'DisplaySKU+desc' }
        ];
        this.updateRoute = () => {
            let route = `Search?query=${this.props.query}&page=${this.state.page}`;
            if (this.state.filterOptions.ConsumerType) {
                route += `&liqType=${this.odataEncode(this.state.filterOptions.ConsumerType)}`;
            }
            if (this.state.filterOptions.ConsumerCategory) {
                route += `&category=${this.odataEncode(this.state.filterOptions.ConsumerCategory)}`;
            }
            if (this.state.filterOptions.country) {
                route += `&country=${this.odataEncode(this.state.filterOptions.country)}`;
            }
            if (this.state.filterOptions.region) {
                route += `&region=${this.odataEncode(this.state.filterOptions.region)}`;
            }
            if (this.state.filterOptions.vintage) {
                route += `&vintage=${this.odataEncode(this.state.filterOptions.vintage)}`;
            }
            if (this.state.filterOptions.ConsumerVarietal) {
                route += `&varietal=${this.odataEncode(this.state.filterOptions.ConsumerVarietal)}`;
            }
            if (this.state.filterOptions.albertaMade) {
                route += `&madeInAlberta=true`;
            }
            history.pushState({}, "Search - Liquor Connect", route.replace("?&", "?"));
        };
        this.updateSubFilter = (newattr, TypeOptions) => {
            let currentFilter = this.state.filterOptions[TypeOptions]
                .split(',')
                .filter((x) => { return x.length > 0; });
            if (currentFilter.includes(newattr)) {
                currentFilter.splice(currentFilter.indexOf(newattr), 1);
            }
            else {
                currentFilter.push(newattr);
            }
            let filterOptions = Object.assign(Object.assign({}, this.state.filterOptions), { skip: 0, top: 24 });
            filterOptions[TypeOptions] = currentFilter.join(',');
            this.setState({
                filterOptions,
                products: [],
                count: 0,
                loading: true
            }, () => {
                this.getProducts(1);
            });
        };
        this.updateAlbertaMade = (newValue) => {
            let filterOptions = Object.assign(Object.assign({}, this.state.filterOptions), { skip: 0, top: 24 });
            filterOptions.albertaMade = newValue;
            this.setState({
                filterOptions,
                products: [],
                count: 0,
                loading: true
            }, () => {
                this.getProducts(1);
            });
        };
        this.updateMinMaxFilter = (newattr, TypeOptions) => {
            let filterOptions = Object.assign(Object.assign({}, this.state.filterOptions), { skip: 0, top: 24 });
            filterOptions[TypeOptions] = newattr;
            this.setState({
                filterOptions,
                products: [],
                count: 0,
                loading: true
            }, () => {
                this.getProducts(1);
            });
        };
        this.updateOrderBy = (orderBy) => {
            this.setState({ orderBy, loading: true, products: [] }, () => this.getProducts(1));
        };
        this.getFacets = (facetsToGet) => __awaiter(this, void 0, void 0, function* () {
            let oDataPath = CONSTS.APIURL;
            let query = `${oDataPath}Products/ConnectMobile.Web.FilterAzurePost()`;
            let facetResults = [];
            for (let i = 0; i < facetsToGet.length; i++) {
                let facet = facetsToGet[i];
                let facetBody = this.getRequestBody(this.facetOptionMap[facet].bodyValues, [facet], true, false, 0, 0, "");
                let promise = axios.post(query, facetBody);
                facetResults.push(this.awaitFacet(facet, promise));
            }
            const results = yield Promise.all(facetResults);
            const newState = results.reduce((accum, result) => {
                let data = (result.data || []);
                data.sort();
                if (result.inFilterOptions) {
                    accum.FilterTypeOptions[result.location] = data;
                }
                else {
                    accum[result.location] = data;
                }
                return accum;
            }, { FilterTypeOptions: Object.assign({}, this.state.FilterTypeOptions) });
            this.setState(newState);
        });
        this.awaitFacet = (facet, promise) => __awaiter(this, void 0, void 0, function* () {
            const facetResult = yield promise;
            let facets = facetResult.data.Facets;
            return this.processFacet(facet, facets);
        });
        this.processFacet = (facet, facets) => {
            var data = facets[facet].filter((x) => { return x.trim().length > 0; });
            switch (this.facetOptionMap[facet].parseNumber) {
                case 'float':
                    data = data.map((x) => { return parseFloat(x).toFixed(1); });
                    break;
                case 'int':
                    data = data.map((x) => { return parseInt(x); });
                    break;
            }
            return Object.assign(Object.assign({}, this.facetOptionMap[facet]), { data });
        };
        this.getRequestBody = (toRemove, facets, includeFacets, includeCount, skip, top, orderBy) => {
            let consumerCategory = this.state.filterOptions.ConsumerCategory == "CIDERS & COOLERS" ?
                "COOLERS" :
                this.state.filterOptions.ConsumerCategory;
            var body = {
                searchText: this.state.filterOptions.searchText,
                country: (this.state.filterOptions.country),
                region: (this.state.filterOptions.region),
                ConsumerCategory: (consumerCategory),
                ConsumerType: (this.state.filterOptions.ConsumerType),
                ConsumerVarietal: (this.state.filterOptions.ConsumerVarietal),
                vintage: (this.state.filterOptions.vintage),
                colour: (this.state.filterOptions.colour),
                container: (this.state.filterOptions.container),
                volumeMin: this.state.filterOptions.volumeMinMax.length > 0 ? this.state.filterOptions.volumeMinMax[0] : -1,
                volumeMax: this.state.filterOptions.volumeMinMax.length > 0 ? this.state.filterOptions.volumeMinMax[1] : -1,
                agentName: (this.state.filterOptions.agent),
                supplier: (this.state.filterOptions.supplier),
                percAlcMin: this.state.filterOptions.percAlcMinMax.length > 0 ? this.state.filterOptions.percAlcMinMax[0] : -1,
                percAlcMax: this.state.filterOptions.percAlcMinMax.length > 0 ? this.state.filterOptions.percAlcMinMax[1] : -1,
                sweetMin: this.state.filterOptions.sweetMinMax.length > 0 ? this.state.filterOptions.sweetMinMax[0] : -1,
                sweetMax: this.state.filterOptions.sweetMinMax.length > 0 ? this.state.filterOptions.sweetMinMax[1] : -1,
                ibuMin: this.state.filterOptions.ibuMinMax.length > 0 ? this.state.filterOptions.ibuMinMax[0] : -1,
                ibuMax: this.state.filterOptions.ibuMinMax.length > 0 ? this.state.filterOptions.ibuMinMax[1] : -1,
                aroma: (this.state.filterOptions.aroma),
                similar: '',
                AgentId: '',
                filter: this.state.filterOptions.albertaMade ? 'MadeInAlberta eq true' : '',
                facets: includeFacets ? facets.join(',') : '',
                includeFacets,
                includeCount,
                orderBy,
                skip,
                top
            };
            for (let i = 0; i < toRemove.length; i++) {
                if (typeof body[toRemove[i]] === 'number') {
                    body[toRemove[i]] = -1;
                }
                else {
                    body[toRemove[i]] = '';
                }
            }
            return body;
        };
        this.getProducts = (page) => {
            const body = this.getRequestBody([], this.allFacets, true, true, (page - 1) * 24, this.state.filterOptions.top, `SponsoredSKU+desc,${this.state.orderBy}`);
            const facestToGet = this.allFacets.reduce((accum, current) => {
                for (let i = 0; i < this.facetOptionMap[current].bodyValues.length; i++) {
                    let bodyValueText = this.facetOptionMap[current].bodyValues[i];
                    let value = body[bodyValueText];
                    if (value != null && value != '' && value != -1) {
                        accum.getIndividually.push(current);
                        return accum;
                    }
                }
                accum.getWithProducts.push(current);
                return accum;
            }, { getWithProducts: [], getIndividually: [] });
            let oDataPath = CONSTS.APIURL;
            let query = `${oDataPath}Products/ConnectMobile.Web.FilterAzurePost()`;
            axios.post(query, body)
                .then((response) => {
                let products = response.data.Products;
                let skip = this.state.filterOptions.skip + 24;
                let newState = {
                    products: _.concat(this.state.products, products),
                    page,
                    count: response.data.Count,
                    filterOptions: Object.assign(Object.assign({}, this.state.filterOptions), { skip }),
                    loading: false,
                };
                this.setState(newState);
                this.updateRoute();
                this.processProductFacets(response.data.Facets, facestToGet.getWithProducts);
                this.getFacets(facestToGet.getIndividually);
            });
        };
        this.processProductFacets = (facetData, facets) => {
            const newState = facets.map(f => this.processFacet(f, facetData)).reduce((accum, result) => {
                let data = (result.data || []);
                data.sort();
                if (result.inFilterOptions) {
                    accum.FilterTypeOptions[result.location] = data;
                }
                else {
                    accum[result.location] = data;
                }
                return accum;
            }, { FilterTypeOptions: Object.assign({}, this.state.FilterTypeOptions) });
            this.setState(newState);
        };
        this.updateSearch = (query) => {
            this.setState({ query });
        };
        this.Search = () => {
            let searchQuery = queryString.stringify({ query: this.state.query });
            location.href = `/Products/Search?${searchQuery}`;
        };
        let searchCat = {
            'Wine': 'WINE',
            'Beer': 'BEER',
            'Liqueurs': 'LIQUEUR',
            'Spirits': 'SPIRITS',
            'Ciders & Coolers': 'CIDERS & COOLERS',
            'Other': 'NON-ALCOHOLIC'
        };
        this.state = {
            loading: true,
            query: this.props.query || "",
            products: [],
            categoryTypes: [],
            categories: [],
            count: 0,
            page: parseInt(this.props.page),
            orderBy: 'search.score()+desc',
            filterOptions: {
                skip: (parseInt(this.props.page) - 1) * 24,
                top: 24,
                searchText: this.props.query,
                country: this.props.country || "",
                region: this.props.region || "",
                ConsumerCategory: this.props.category || "",
                ConsumerType: this.props.liqtype || "",
                ConsumerVarietal: this.props.varietal || "",
                vintage: this.props.vintage || "",
                colour: "",
                container: "",
                volumeMinMax: [],
                agent: "",
                supplier: "",
                percAlcMinMax: [],
                sweetMinMax: [],
                ibuMinMax: [],
                aroma: "",
                albertaMade: this.props.madeinalberta
            },
            FilterTypeOptions: {
                Country: [],
                Vintage: [],
                Region: [],
                Varietal: [],
                Colours: [],
                Containers: [],
                Volumes: [],
                Agents: [],
                Suppliers: [],
                PercentAlcohols: [],
                Sweetnesses: [],
                Ibus: [],
                Aromas: []
            }
        };
    }
    odataEncode(text) {
        return encodeURIComponent(text).replace(/'/g, "''");
    }
    filterToAzure(text) {
        let newText = text
            .split(',')
            .map((item) => { return `"${item}"`; })
            .join('||');
        return text.length > 0 ? encodeURIComponent(newText) : "";
    }
    componentDidMount() {
        return __awaiter(this, void 0, void 0, function* () {
            this.getProducts(parseInt(this.props.page));
        });
    }
    render() {
        return (React.createElement(ResultView, { categoryTypes: this.state.categoryTypes, categories: this.state.categories, newQuery: this.state.query, query: this.props.query, products: this.state.products, getProducts: this.getProducts, typeSelected: this.state.filterOptions.ConsumerType, country: this.state.filterOptions.country, region: this.state.filterOptions.region, vintage: this.state.filterOptions.vintage, varietal: this.state.filterOptions.ConsumerVarietal, category: this.state.filterOptions.ConsumerCategory, colour: this.state.filterOptions.colour, container: this.state.filterOptions.container, volumeMinMax: this.state.filterOptions.volumeMinMax, agent: this.state.filterOptions.agent, supplier: this.state.filterOptions.supplier, percAlcMinMax: this.state.filterOptions.percAlcMinMax, sweetMinMax: this.state.filterOptions.sweetMinMax, ibuMinMax: this.state.filterOptions.ibuMinMax, albertaMade: this.state.filterOptions.albertaMade, aroma: this.state.filterOptions.aroma, count: this.state.count, page: this.state.page, loading: this.state.loading, FilterTypeOptions: this.state.FilterTypeOptions, updateSubFilter: this.updateSubFilter, updateMinMaxFilter: this.updateMinMaxFilter, updateAlbertaMade: this.updateAlbertaMade, updateSearch: this.updateSearch, Search: this.Search, updateOrderBy: this.updateOrderBy, orderByOptions: this.orderByOptions, currentOrderBy: this.state.orderBy }));
    }
}
;
//# sourceMappingURL=search-results.js.map